/**
 * Bearbeitungsregeln für Notizen, die Server und Offline-Client gleich anwenden.
 */
import { applyCharacterLevel, normalizeSheet } from './sheet.js';
import { normalizeStatblock } from './statblock.js';

/** Statblock und Charakterbogen im Frontmatter in die kompakte, geprüfte Form bringen. */
export function cleanFrontmatter(fm: Record<string, unknown>): Record<string, unknown> {
  let out = fm;
  if (out.statblock && typeof out.statblock === 'object' && !Array.isArray(out.statblock)) {
    out = { ...out, statblock: normalizeStatblock(out.statblock) };
  }
  if (out.sheet !== undefined) {
    const sheet = normalizeSheet(out.sheet);
    out = { ...out };
    if (Object.keys(sheet).length) out.sheet = sheet;
    else delete out.sheet;
  }
  // Charaktere ohne HG: Übungsbonus aus der Stufe
  return applyCharacterLevel(out);
}

/** Einzelne Eigenschaften setzen/entfernen. */
export function patchFrontmatter(fm: Record<string, unknown>, set: Record<string, unknown>, unset: readonly string[]): Record<string, unknown> {
  const out = { ...fm, ...set };
  for (const k of unset) delete out[k];
  return out;
}
